import React from 'react';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';

interface TextInputProps {
    value: string;
    label: string;
    name?: string;
    required?: boolean;
    handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleOnBlur?: () => void;
    handleKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    fullWidth?: boolean;
    endAdornment?: React.ReactNode;
    title?: string;
    helperText?: string;
    error?: boolean;
    startAdornment?: React.ReactNode;
}

const TextInput: React.FC<TextInputProps> = ({
    value,
    label,
    name,
    required,
    handleChange,
    handleOnBlur,
    handleKeyDown,
    disabled,
    fullWidth,
    endAdornment,
    title,
    helperText,
    error,
    startAdornment,
}) => {
    return (
        <div>
            <TextField
                fullWidth={fullWidth}
                className="bg-white"
                required={required}
                disabled={disabled}
                id="outlined-basic"
                label={label}
                name={name}
                helperText={helperText}
                variant="outlined"
                value={value}
                onChange={handleChange}
                onBlur={handleOnBlur}
                onKeyDown={handleKeyDown}
                error={error}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {endAdornment}
                        </InputAdornment>
                    ),
                    startAdornment: (
                        <InputAdornment position="start">
                            {startAdornment}
                        </InputAdornment>
                    ),
                    title,
                }}
            />
        </div>
    );
};

export default TextInput;
